<template>
  <div class="row justify-center">
    <div class="col-12 col-lg-10">
      <div>
        <div class="d-flex justify-center mb-4">
          <img
            src="@/assets/ill/il-pelaporan-berhasil.svg"
            alt=""
            v-if="report.status == 'Pelaporan Berhasil'"
          />
          <img src="@/assets/ill/il-pelaporan-gagal.svg" alt="" v-else />
        </div>
        <h2
          class="text-center text-green fz-16 fw-700 text-uppercase"
          v-if="report.status == 'Pelaporan Berhasil'"
        >
          {{ report.status }}
        </h2>
        <h2 class="text-center text-red fz-16 fw-700 text-uppercase" v-else>
          {{ report.status }}
        </h2>
      </div>
      <br />
      <hr class="my-5" style="border-style: dashed" />
      <div class="card-danger" v-if="report.status == 'Pelaporan Gagal'">
        <p class="fw-700 text-red mb-1">
          {{ report.statusremarks }}
        </p>
        <p class="mb-0 fz-14">
          {{ report.remarks }}
        </p>
      </div>
      <br />
      <div class="card">
        <div class="card-body">
          <div class="d-flex justify-space-between pt-3">
            <p class="fz-14 mb-0 text-gray-4">
              REPORT #{{ report.laporjualid }}
            </p>
            <p class="fz-14 mb-0 text-gray-4">
              {{ formatDate(report.laporjualdate) }}
            </p>
          </div>
          <hr />
          <div class="">
            <p class="fz-14 fw-700 text-gray-4">
              PELAPOR
              <span class="badge-gray ml-3">{{ report.tindak_selaku }}</span>
            </p>
            <p class="fz-20 fw-700 mb-1">{{ report.laporjualname }}</p>
            <p class="text-gray-4">
              {{ report.laporjualaddress }}
            </p>
            <div class="d-flex">
              <box-icon
                type="solid"
                color="#9DA7AF"
                name="user-rectangle"
              ></box-icon>
              <p class="mb-0 text-gray-4 ml-2">{{ report.nik }}</p>
            </div>
            <div class="d-flex">
              <box-icon type="solid" color="#9DA7AF" name="phone"></box-icon>
              <p class="mb-0 text-gray-4 ml-2">{{ report.no_hp }}</p>
            </div>
          </div>
          <hr />
          <div class="">
            <p class="fz-14 fw-700 text-gray-4 mb-2">PELAPORAN</p>
            <p>{{ report.alasan }}</p>
            <div class="card">
              <div class="card-body">
                <p class="fw-700">Laporan</p>
                <atom-table
                  label="Nomor Registrasi (Nopol)"
                  :value="report.detailPajak.nopol"
                />
                <atom-table
                  label="Jenis Kendaraan"
                  :value="report.jeniskendaraan"
                />
                <atom-table
                  label="Merk/Type"
                  :value="`${report.detailPajak.merk}/${report.detailPajak.type}`"
                />
                <atom-table label="Nomor Handphone" :value="report.no_hp" />
                <atom-table label="No KK/KTP" :value="report.nik" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "HistoryDetail",
  components: {
    AtomTable: () => import("@/components/atoms/AtomTable.vue"),
  },
  computed: {
    report() {
      return this.$store.state.main.report;
    },
  },
  methods: {
    formatDate(date) {
      return moment(date).format("ll");
    },
  },
  created() {
    this.$store.dispatch("DetailVehicle", this.$route.params.id);
  },
};
</script>
